/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioStatus } from './InternalApiScenarioStatus';
import {
    InternalApiScenarioStatusFromJSON,
    InternalApiScenarioStatusFromJSONTyped,
    InternalApiScenarioStatusToJSON,
    InternalApiScenarioStatusToJSONTyped,
} from './InternalApiScenarioStatus';
import type { InternalApiRiskRuleVersion } from './InternalApiRiskRuleVersion';
import {
    InternalApiRiskRuleVersionFromJSON,
    InternalApiRiskRuleVersionFromJSONTyped,
    InternalApiRiskRuleVersionToJSON,
    InternalApiRiskRuleVersionToJSONTyped,
} from './InternalApiRiskRuleVersion';

/**
 * 
 * @export
 * @interface InternalApiRiskRule
 */
export interface InternalApiRiskRule {
    /**
     * 
     * @type {string}
     * @memberof InternalApiRiskRule
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiRiskRule
     */
    name: string;
    /**
     * 
     * @type {InternalApiScenarioStatus}
     * @memberof InternalApiRiskRule
     */
    status: InternalApiScenarioStatus;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiRiskRule
     */
    updatedTime: Date;
    /**
     * 
     * @type {Array<InternalApiRiskRuleVersion>}
     * @memberof InternalApiRiskRule
     */
    versions: Array<InternalApiRiskRuleVersion>;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiRiskRule
     */
    calculationInProgress?: boolean;
}



/**
 * Check if a given object implements the InternalApiRiskRule interface.
 */
export function instanceOfInternalApiRiskRule(value: object): value is InternalApiRiskRule {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('updatedTime' in value) || value['updatedTime'] === undefined) return false;
    if (!('versions' in value) || value['versions'] === undefined) return false;
    return true;
}

export function InternalApiRiskRuleFromJSON(json: any): InternalApiRiskRule {
    return InternalApiRiskRuleFromJSONTyped(json, false);
}

export function InternalApiRiskRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRiskRule {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'status': InternalApiScenarioStatusFromJSON(json['status']),
        'updatedTime': (new Date(json['updatedTime'])),
        'versions': ((json['versions'] as Array<any>).map(InternalApiRiskRuleVersionFromJSON)),
        'calculationInProgress': json['calculationInProgress'] == null ? undefined : json['calculationInProgress'],
    };
}

export function InternalApiRiskRuleToJSON(json: any): InternalApiRiskRule {
    return InternalApiRiskRuleToJSONTyped(json, false);
}

export function InternalApiRiskRuleToJSONTyped(value?: InternalApiRiskRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'status': InternalApiScenarioStatusToJSON(value['status']),
        'updatedTime': value['updatedTime'].toISOString(),
        'versions': ((value['versions'] as Array<any>).map(InternalApiRiskRuleVersionToJSON)),
        'calculationInProgress': value['calculationInProgress'],
    };
}

